import { Staff } from "./staff";
 
// Recurring options as a TypeScript enum
export enum Recurring {
  NONE = 'none',
  DAILY = 'day',
  WEEKLY = 'week',
  MONTHLY = 'month',
  YEARLY = 'year',
}
export interface BookingType {
  id: number;
  bookingTypeCategoryId: number;
  title: string;
  start: string;
  end: string;
  recurringInterval: number;
  recurring: Recurring;
  price: number,
  location: string;
  meetingLocationTypeId: string;
  desc: string;
  color: string;
  link: string;
  length: number;
  bookingSize: string;
  maxInvitees: number;
  showRemaining: boolean; 
  increments: number;
  bookingPerDay: number;
  isVisibleToStaff: boolean;
  isPublic: boolean;
  displayOnBookingPage: boolean;
  phonenumber: string;
  canInviteeCall: boolean;
  image: number;
  deleted: boolean;
  bookingApproval: number; 
  createdBy: number;
  assignedStaffs: Staff[];
}
